namespace RioERP.Orders {
    export namespace OrderTeacherShareCalculationService {
        export const baseUrl = 'Orders/OrderTeacherShareCalculation';

        export declare function Create(request: Serenity.SaveRequest<OrderTeacherShareCalculationRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<OrderTeacherShareCalculationRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<OrderTeacherShareCalculationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<OrderTeacherShareCalculationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Orders/OrderTeacherShareCalculation/Create",
            Update = "Orders/OrderTeacherShareCalculation/Update",
            Delete = "Orders/OrderTeacherShareCalculation/Delete",
            Retrieve = "Orders/OrderTeacherShareCalculation/Retrieve",
            List = "Orders/OrderTeacherShareCalculation/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>OrderTeacherShareCalculationService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
